import { getEnumTmntTypeValues    } from '../autogen/bundle.js';
import { getEnumTmntTypeName      } from '../autogen/bundle.js';
import { getEnumTmntStatusName    } from '../autogen/bundle.js';
import { getEnumTmntMedalName     } from '../autogen/bundle.js';
import { getStrWithLowFirstLetter } from '../util.js';
import { getDurationStr           } from '../util.js';
import { getDurationStrSimple     } from '../util.js';
import { getOptionalTextMomentStr } from '../util.js';
import { isNumberSpecified        } from '../util.js';
import { isRoleAdmin              } from '../util.js';
import { isLocalOrProd            } from '../util.js';

import { convertDurationSecToMMSSStr } from '../time.js';

/**
 * @typedef { import('../auth.js').Role } Role
 */

/**
 * @typedef { import('./event.js').PlayerGroupId } PlayerGroupId
 */

//-----------------------------------------------------------------------------

/**
 * @typedef {number} ContestType
 */

export const CONTEST_TYPE_NONE            = 0;
export const CONTEST_TYPE_INDIVIDUAL      = 1;
export const CONTEST_TYPE_CHAMP           = 2;
export const CONTEST_TYPE_CHAMPS          = 2; // Deprecated. Use CONTEST_TYPE_CHAMP.
export const CONTEST_TYPE_CLUBS           = 3;
export const CONTEST_TYPE_TEA             = 4; // Old name: chest.
export const CONTEST_TYPE_BUGZ            = 5;
export const CONTEST_TYPE_GVNT            = 6;
export const CONTEST_TYPE_RAINBOW_RUSH    = 7;
export const CONTEST_TYPE_BAKERY_MARATHON = 8;

/** @returns {ContestType[]} */
export function getSortedContestTypes() {
  const typeList = [
    CONTEST_TYPE_CHAMPS,
    CONTEST_TYPE_INDIVIDUAL,
    CONTEST_TYPE_TEA,
    CONTEST_TYPE_BUGZ,
    CONTEST_TYPE_CLUBS,
    CONTEST_TYPE_GVNT,
    CONTEST_TYPE_RAINBOW_RUSH,
    CONTEST_TYPE_BAKERY_MARATHON,
  ];

  for(const t of getEnumTmntTypeValues()) {
    if(t === CONTEST_TYPE_NONE) {
      continue;
    }
    if(!typeList.includes(t)) {
      typeList.push(t);
    }
  }

  return typeList;
}

/**
 * @param {ContestType} typeCode
 * @returns {?string}
 */
export function getContestTypeNameFull(typeCode) {
  const nameRu   = getContestTypeNameRu(typeCode);
  const nameCode = getContestTypeName(typeCode);

  if(nameRu !== null) {
    return nameRu + ' (' + nameCode + ')';
  }

  return nameCode;
}

/**
 * @param {ContestType} typeCode
 * @returns {?string}
 */
export function getContestTypeNameRu(typeCode) {
  switch(typeCode) {
    case CONTEST_TYPE_INDIVIDUAL:   return 'светский раут';
    case CONTEST_TYPE_CHAMPS:       return 'высший свет';
    case CONTEST_TYPE_CLUBS:        return 'первенство клубов';
    case CONTEST_TYPE_TEA:          return 'чаепитие'; // Old name: chest.
    case CONTEST_TYPE_BUGZ:         return 'прогулка в саду';
    case CONTEST_TYPE_GVNT:         return null;
    case CONTEST_TYPE_RAINBOW_RUSH: return 'радужный раж';
    case CONTEST_TYPE_BAKERY_MARATHON: return 'булочный марафон';
  }

  return null;
}

/**
 * @param {ContestType} typeCode
 * @returns {string}
 */
export function getContestTypeName(typeCode) {
  switch(typeCode) {
    case CONTEST_TYPE_CHAMPS:       return 'champ';
    case CONTEST_TYPE_CLUBS:        return 'club';
    case CONTEST_TYPE_TEA:          return 'tea';
    case CONTEST_TYPE_BUGZ:         return 'bug';
    case CONTEST_TYPE_RAINBOW_RUSH: return 'rainbow';
    case CONTEST_TYPE_BAKERY_MARATHON: return 'bakery marathon';
  }

  const name = getEnumTmntTypeName(typeCode);
  return getStrWithLowFirstLetter(name);
}

// options for component b-form-select
export function getContestTypeOptions() {
  const options = [];

  const typeList = getSortedContestTypes();
  for(const t of typeList) {
    const option = {
      value: t,
      text: getContestTypeName(t),
    };
    options.push(option);
  }

  return options;
}

// options for component b-form-select
export function getContestTypeOptionsFull() {
  const options = [];

  const typeList = getSortedContestTypes();
  for(const t of typeList) {
    const option = {
      value: t,
      text: getContestTypeNameFull(t),
    };
    options.push(option);
  }

  return options;
}

// options for component b-form-select
export function getContestTypeOptionsForFilter() {
  const options = getContestTypeOptions();

  const nullOption = {
    value: null,
    text: 'any',
  };
  options.unshift(nullOption);

  return options;
}

//-----------------------------------------------------------------------------

/**
 * @typedef {number} GroupCreationRule
 */

// При старте конкурса группы не создаются.
// Группы создаются, когда игроки присоединяются к конкурсу.
/** @type {GroupCreationRule} */
export const GROUP_CREATION_RULE__DYNAMIC = 1;

// Все группы создаются при старте конкурса.
// При проведении конкурса новые группы не создаются.
/** @type {GroupCreationRule} */
export const GROUP_CREATION_RULE__STATIC  = 2;

/** @returns {ContestType[]} */
export function getGroupCreationRules() {
  return [
    GROUP_CREATION_RULE__DYNAMIC,
    GROUP_CREATION_RULE__STATIC,
  ];
}

/**
 * @param {GroupCreationRule} rule
 * @returns {string}
 */
export function getGroupCreationRuleName(rule) {
  switch(rule) {
    case GROUP_CREATION_RULE__DYNAMIC: return 'dynamic';
    case GROUP_CREATION_RULE__STATIC:  return 'static';
  }
  return '?';
}

/**
 * @param {GroupCreationRule} rule
 * @returns {?string}
 */
export function getGroupCreationRuleDescription(rule) {
  switch(rule) {
    case GROUP_CREATION_RULE__DYNAMIC: {
      let d = '';
      d += 'При старте конкурса группы не создаются.\n';
      d += 'Группы создаются, когда игроки присоединяются к конкурсу.';
      return d;
    }

    case GROUP_CREATION_RULE__STATIC: {
      let s = '';
      s += 'Все группы создаются при старте конкурса.\n';
      s += 'При проведении конкурса новые группы не создаются.';
      return s;
    }
  }

  return null;
}

/**
 * @param {ContestType} contestType
 * @returns {boolean}
 */
export function isGroupCreationRuleSupported(contestType) {
  return contestType === CONTEST_TYPE_CHAMPS;
}

// options for component b-form-select
export function getGroupCreationRuleOptions() {
  const options = [];

  const rules = getGroupCreationRules();
  for(const rule of rules) {
    const option = {
      value: rule,
      text: getGroupCreationRuleName(rule),
    };
    options.push(option);
  }

  return options;
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} ContestPreview
 * @property {number}        id
 * @property {number}        type
 * @property {PlayerGroupId} playerGroupId
 * @property {ContestStatus} status
 * @property {number}        stime
 * @property {number}        srtime
 * @property {number}        ftime
 * @property {number}        frtime
 */

/**
 * @typedef {Object} ContestPreviewContainer
 * @property {ContestPreview} contest
 * @property {boolean}        selected
 */

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} Contest
 * @property {number} id
 * @property {number} type
 * @property {PlayerGroupId} playerGroupId
 * @property {number} clientMinVersionCode
 * @property {ContestStatus} status
 * @property {number} ctime
 * @property {number} stime
 * @property {number} srtime
 * @property {number} ftime
 * @property {number} frtime
 * @property {number} arg1
 */


/**
 * @param {ContestType} contestType
 * @returns {boolean}
 */
export function canDownloadRatingsJSON(contestType) {
  switch(contestType) {
    case CONTEST_TYPE_INDIVIDUAL:
    case CONTEST_TYPE_CHAMPS:
    case CONTEST_TYPE_CLUBS:
    case CONTEST_TYPE_TEA:
    case CONTEST_TYPE_BUGZ:
    case CONTEST_TYPE_RAINBOW_RUSH:
    case CONTEST_TYPE_BAKERY_MARATHON:
      return true;
  }
  return false;
}

/**
 * @param {ContestType} contestType
 * @returns {boolean}
 */
export function canDownloadRatingsCSV(contestType) {
  switch(contestType) {
    case CONTEST_TYPE_INDIVIDUAL:
    case CONTEST_TYPE_CHAMPS:
    case CONTEST_TYPE_CLUBS:
    case CONTEST_TYPE_TEA:
    case CONTEST_TYPE_BUGZ:
    case CONTEST_TYPE_RAINBOW_RUSH:
    case CONTEST_TYPE_BAKERY_MARATHON:
      return true;
  }
  return false;
}

/**
 * @param {ContestType} contestType
 * @returns {boolean}
 */
export function canSaveRatingsForDashboards(contestType) {
  switch(contestType) {
    case CONTEST_TYPE_INDIVIDUAL:       return true;
    case CONTEST_TYPE_CHAMPS:           return true;
    case CONTEST_TYPE_CLUBS:            return true;
    case CONTEST_TYPE_TEA:              return true;
    case CONTEST_TYPE_BUGZ:             return true;
    case CONTEST_TYPE_RAINBOW_RUSH:     return true;
    case CONTEST_TYPE_BAKERY_MARATHON:  return true;
  }
  return false;
}

export const TMNT_STARTING_TYPE_IMMEDIATELY = 1;
export const TMNT_STARTING_TYPE_DEFFERED    = 2;

/**
 * @param {number} code
 * @returns {string}
 */
export function getTmntStartingTypeName(code) {
  switch(code) {
    case TMNT_STARTING_TYPE_IMMEDIATELY: return 'immediately';
    case TMNT_STARTING_TYPE_DEFFERED:    return 'deffered';
  }
  return `Unknown tmnt starting type ${code}.`;
}

/**
 * @typedef {number} ContestStatus
 */

export const CONTEST_STATUS_ACTIVE   = 1;
export const CONTEST_STATUS_FINISHED = 2;
export const CONTEST_STATUS_INCOMING = 3;
export const CONTEST_STATUS_CLOSED   = 4;

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function isContestIncoming(status) {
  return status === CONTEST_STATUS_INCOMING;
}

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
 export function isContestFinished(status) {
  return status === CONTEST_STATUS_FINISHED;
}

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function isContestActive(status) {
  return status === CONTEST_STATUS_ACTIVE;
}

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function isContestClosed(status) {
  return status === CONTEST_STATUS_CLOSED;
}

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function canContestHaveGross(status) {
  switch(status) {
    case CONTEST_STATUS_INCOMING: return false;
    case CONTEST_STATUS_ACTIVE:   return true;
    case CONTEST_STATUS_FINISHED: return true;
    case CONTEST_STATUS_CLOSED:   return true;
  }

  throw new Error('Unknown contest status.');
}

// options for component b-form-select
export function getContestStatusOptionsForFilter() {
  const options = getContestStatusOptions();

  const nullOption = {
    value: null,
    text: 'any',
  };
  options.unshift(nullOption);

  return options;
}

function getContestStatusOptions() {
  const options = [];

  const statusList = getContestStatuses();
  for(const status of statusList) {
    const option = {
      value: status,
      text: getContestStatusName(status),
    };
    options.push(option);
  }

  return options;
}

// see EnumTmntStatus
function getContestStatuses() {
  return [
    3, // incoming
    1, // active
    2, // finished (it's finished but players are still allowed to take rewards)
    4, // closed   (completely closed, no more rewards)
  ];
}

//-----------------------------------------------------------------------------

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function isContestEditable(status) {
  return isContestStimeEditable(status) || isContestFtimeEditable(status);
}

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function isContestStimeEditable(status) {
  return isContestIncoming(status);
}

/**
 * @param {ContestStatus} status
 * @returns {boolean}
 */
export function isContestFtimeEditable(status) {
  return isContestIncoming(status) || isContestActive(status);
}

//-----------------------------------------------------------------------------

/**
 * @param {number} typeCode
 * @returns {string}
 */
export function getEnumTmntStatusNameFormatted(typeCode) {
  const name = getEnumTmntStatusName(typeCode);
  return getStrWithLowFirstLetter(name);
}

/**
 * @param {number} status
 * @returns {string}
 */
export function getContestStatusName(status) {
  return getEnumTmntStatusNameFormatted(status);
}

/**
 * @param {number} typeCode
 * @returns {string}
 */
export function getEnumTmntMedalNameFormatted(typeCode) {
  const name = getEnumTmntMedalName(typeCode);
  return getStrWithLowFirstLetter(name);
}

/**
 * @param {ContestStatus} status
 * @returns {Object}
 */
export function getContestStatusClass(status) {
  return {
    activeContest:   isContestActive(status),
    finishedContest: isContestFinished(status),
  };
}

/**
 * @param {Contest} contest
 * @returns {number}
 */
export function getContestPlannedDuration(contest) {
  return contest.ftime - contest.stime;
}

/**
 * @param {Contest} contest
 * @returns {string}
 */
export function getContestPlannedDurationStr(contest) {
  const plannedDuration = getContestPlannedDuration(contest);
  return getDurationStr(plannedDuration);
}

/**
 * @param {Contest} contest
 * @param {number} nowSec
 * @returns {string}
 */
export function getContestRemainingTimeStr(contest, nowSec) {
  if(contest.status === CONTEST_STATUS_INCOMING) {
    return 'incoming';
  }

  if(contest.status === CONTEST_STATUS_FINISHED) {
    return 'finished';
  }

  const timeEnded = nowSec >= contest.ftime;
  if(timeEnded) {
    return 'time ended';
  }

  const remainintTime = contest.ftime - nowSec;
  return getDurationStrSimple(remainintTime);
}

/**
 * @param {number} srtime
 * @returns {string}
 */
export function getContestRealStartTimeStr(srtime) {
  return getOptionalTextMomentStr(srtime, 'not started');
}

/**
 * @param {number} frtime
 * @returns {string}
 */
export function getContestRealFinishTimeStr(frtime) {
  return getOptionalTextMomentStr(frtime, 'not finished');
}

/**
 * @param {Contest} tmnt
 * @returns {string}
 */
export function getTmntRealDurationStrSimple(tmnt) {
  if(!isNumberSpecified(tmnt.srtime)) {
    return 'not started';
  }
  if(!isNumberSpecified(tmnt.frtime)) {
    return 'not finished';
  }
  const realDuration = tmnt.frtime - tmnt.srtime;
  return getDurationStrSimple(realDuration);
}

/**
 * @param {Contest} contest
 * @returns {string}
 */
export function getContestRealDurationStrSimple(contest) {
  return getTmntRealDurationStrSimple(contest);
}

/**
 * @typedef {Object} LeagueStat
 * @property {number} id
 * @property {number} groupAmount
 * @property {number} participantAmount
 * @property {number} participantUpAmount
 * @property {number} participantDownAmount
 */

/**
 * @param {LeagueStat[]} leagues
 * @returns {number}
 */
export function calcContestParticipantAmount(leagues) {
  let contestParticipantAmount = 0;
  for(const league of leagues) {
    contestParticipantAmount += league.participantAmount;
  }
  return contestParticipantAmount;
}

/**
 * @param {Role} role
 * @returns {boolean}
 */
export function mayManageContests(role) {
  return isRoleAdmin(role);
}

/**
 * @param {Role} role
 * @returns {boolean}
 */
export function mayImportContestsToClickHouse(role) {
  // Импорт выполняется в ClickHouse. Есть только 1 ClickHouse. Он один для стейджа и прода.
  // В этот ClickHouse можно сохранять только данные из прода.
  // Импорт из стейджа запрещен.
  return isLocalOrProd() && mayManageContests(role);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} ContestGroupImportObject
 * @property {number} id
 * @property {number} stime
 * @property {number} ftime
 * @property {number} durationMSec
 */

//-----------------------------------------------------------------------------

/**
 * @param {ContestType} contestType
 * @returns {boolean}
 */
export function isClientMinVersionSupported(contestType) {
  switch(contestType) {
    case CONTEST_TYPE_INDIVIDUAL:
    case CONTEST_TYPE_TEA:
    case CONTEST_TYPE_BUGZ:
    case CONTEST_TYPE_RAINBOW_RUSH:
    case CONTEST_TYPE_BAKERY_MARATHON:
      return true;
  }
  return false;
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} RatingPreview
 * @property {number} id
 */

//-----------------------------------------------------------------------------

// Поле ctime используется только для конкурсов "Радужный раж".
export function getMetricTimeStr(metric) {
  if(metric.tmnt_type === CONTEST_TYPE_RAINBOW_RUSH) {
    return convertDurationSecToMMSSStr(metric.ctime);
  }

  // Для всех конкуров (кроме конкрурса "Радужный раж")
  // ctime должно быть равно 0.
  if(metric.ctime !== 0) {
    return 'Error';
  }

  return null;
}

//-----------------------------------------------------------------------------
